import('./services/initialize.service').then((module) => module.initApp());
